import {QueryOptions} from "@apollo/client";
import {
    GetBookedAttendeesByCourseIdDocument,
    GetBookingsByAttendeeIdWithOptionsDocument,
    GetBookingsByCourseDocument,
    GetCourseByIdDocument,
    GetCourseDetailsByIdDocument,
    GetFreePlacesByCourseIdDocument,
    GetScheduledPaymentsByBookingIdDocument,
    GetWaitlistByCourseDocument,
} from "../../../../generated/graphql";

export const refetchQueriesForAll = ({bookingId, courseId, attendeeId}: {bookingId: string; courseId?: string; attendeeId?: string}): Array<string | QueryOptions> => {
    const refetchQueries: Array<string | QueryOptions> = [
        "GetBookingsOverviewOptimized",
        "GetUnsettledBookings",
        "GetSettledBookings",
        "GetScheduledPaymentsByBookingId",
        {
            query: GetScheduledPaymentsByBookingIdDocument,
            variables: {bookingId},
        },
    ];

    if (courseId) {
        refetchQueries.push(
            "getFreePlacesByCourseId",
            {
                query: GetFreePlacesByCourseIdDocument,
                variables: {id: courseId},
            },
            "GetBookingsByCourse",
            {
                query: GetBookingsByCourseDocument,
                variables: {id: courseId},
            },
            "GetBookedAttendeesByCourseId",
            {
                query: GetBookedAttendeesByCourseIdDocument,
                variables: {courseId},
            },
            "GetWaitlistByCourse",
            {
                query: GetWaitlistByCourseDocument,
                variables: {id: courseId},
            },
            "getCourseById",
            {
                query: GetCourseByIdDocument,
                variables: {id: courseId},
            },
            "GetCourseDetailsById",
            {
                query: GetCourseDetailsByIdDocument,
                variables: {id: courseId},
            },
        );
    }

    if (attendeeId) {
        refetchQueries.push("GetBookingsByAttendeeIdWithOptions", {
            query: GetBookingsByAttendeeIdWithOptionsDocument,
            variables: {id: attendeeId},
        });
    }

    return refetchQueries;
};
